import React from "react";
import WhiteButton from "../../../../../Components/WhiteButton";
import { ArrowRight } from "lucide-react";
import BlackButton from "../../../../../Components/BlackButton";
import { useNavigate } from "react-router-dom";

const AboutUsDetailCard = ({ title, description, imageUrl, left = true }) => {
  const navigate = useNavigate();

  return (
    <div
      className={`flex flex-col-reverse ${
        left ? "md:flex-row" : "md:flex-row-reverse"
      } md:space-x-16 justify-center items-center`}
    >
      <div className="mt-5 md:mt-0 md:hidden">
        <WhiteButton
          text="Explore Careers"
          icon={<ArrowRight />}
          onClick={() => console.log("Explore Project")}
        />
      </div>

      <div
        className={`relative overflow-hidden text-white h-[480px] w-full md:w-auto md:min-w-[50%] flex flex-row`}
      >
        <img
          src={imageUrl}
          alt="AI Strategy"
          className="w-full h-full object-cover absolute object-center grayscale"
        />
        {/* Top Shadow */}
        <div className="absolute top-0 left-0 w-full h-12 bg-gradient-to-b from-app-background to-transparent z-10" />

        {/* Bottom Shadow */}
        <div className="absolute bottom-0 left-0 w-full h-12 bg-gradient-to-t from-app-background to-transparent z-10" />

        {/* Left Shadow */}
        <div className="absolute top-0 left-0 h-full w-12 bg-gradient-to-r from-app-background to-transparent z-10" />

        {/* Right Shadow */}
        <div className="absolute top-0 right-0 h-full w-12 bg-gradient-to-l from-app-background to-transparent z-10" />
      </div>

      <div className="flex flex-col items-start">
        <BlackButton
          text={title}
          padding="py-1 md:py-2 px-2 md:px-4"
          textClassName="text-sm md:text-lg font-normal font-theBrittanySans"
        />
        <p className="text-xl leading-[145%] tracking-[0%] mt-4 mb-5 md:mb-12">
          {description}
        </p>
        <div className="hidden md:block">
          <WhiteButton
            text="Explore Careers"
            icon={<ArrowRight />}
            onClick={() => navigate("/careers")}
          />
        </div>
      </div>
    </div>
  );
};

export default AboutUsDetailCard;
